import { render, staticRenderFns } from "./interactiveHumanBody.vue?vue&type=template&id=3ed98c4a&scoped=true"
import script from "./interactiveHumanBody.vue?vue&type=script&lang=js"
export * from "./interactiveHumanBody.vue?vue&type=script&lang=js"
import style0 from "./interactiveHumanBody.vue?vue&type=style&index=0&id=3ed98c4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed98c4a",
  null
  
)

export default component.exports